export class LanguageAndFlag {
  language!: string;
  flag!: string;
}

export const languageToFlag = new Map<string, string>([
  ['en', 'gb'],
  ['nl', 'nl'],
  ['zh', 'cn'],
  ['es', 'es'],
  ['fr', 'fr'],
  ['de', 'de'],
]);

/**
 * All UI locales the app ships translation files for (see
 * `src/assets/i18n/`). This list is intentionally decoupled from the
 * backend's `UserDto.LanguageEnum`, which currently only covers a
 * subset of these locales for persistence. The login screen and other
 * language-switcher surfaces must offer every locale the user can
 * actually read — persistence compatibility is a separate concern.
 *
 * TODO(backend): expand `UserDto.LanguageEnum` to include all six
 * locales so that saving a user's preferred language from the profile
 * form doesn't fail for de/es/fr.
 */
export const SUPPORTED_UI_LANGUAGES = ['en', 'nl', 'de', 'fr', 'es', 'zh'] as const;

export const languagesAndFlags: LanguageAndFlag[] = SUPPORTED_UI_LANGUAGES.map(
  (language) => ({language, flag: languageToFlag.get(language)!}),
);
